import { $BookingItem } from './BookingModel'

export interface $Treatment {
  _id: string
  treatmentId: string
  name: string
  price: number
  duration: number
  fee: number
  type: string
  isOption: boolean
  shortDescription: string
  selected: boolean
  info: Array<$TreatmentInfo>
  optionGroups: Array<$TreatmentOptionGroup>
}

export interface $TreatmentInfo {
  title: string
  body: string
}

export interface $TreatmentOptionGroup {
  name: string
  multiSelect: boolean
  defaultIndex: number | null
  options: Array<$Treatment>
  optionIds?: Array<string>
}

export interface $BookingOptionGroup {
  name: string
  defaultIndex: string
  multiSelect: string
  options: Array<$Treatment>
}

// Address
export interface $Address {
  _id?: string
  userId?: string
  isDefault: boolean,
  label: string
  firstLine: string
  secondLine: string
  city: string
  county: string
  postalCode: string
}

// Computes item total
export const itemTotal = (item: $BookingItem, key: 'duration') => {
  const { treatment } = item

  let total: number = treatment[key] || 0

  treatment.optionGroups!.forEach((og: $TreatmentOptionGroup) => {
    og.options.forEach((o: $Treatment) => {
      if (o.selected) total += o[key] || 0
    })
  })

  return total
}

export const bookingItemsTotal = (items: Array<$BookingItem>, key: 'duration') => {
  return items.reduce((a: number, b: $BookingItem) => {
    return a + itemTotal(b, key)
  }, 0)
}

// Computes item description
export const itemDescription = (item: $BookingItem) => {
  const { treatment } = item

  const strs: Array<string> = []

  treatment.optionGroups!.forEach((og: $TreatmentOptionGroup) => {
    og.options.forEach((o: $Treatment) => {
      if (o.selected) strs.push(o.name)
    })
  })

  return strs.join(', ')
}

export const addressAsString = (address: $Address) => {
  if (!address) return ''

  const addr = [address.firstLine, address.secondLine, address.county, address.city, address.postalCode].filter(Boolean).join(', ')
  return addr
}
